import { observer } from 'mobx-react-lite';

import { HeadLine, HeadLineMore } from '@/components/common/HeadLine';
import KeywordRanking from '@/components/common/KeywordRanking';

import useStore from '@/hooks/useStore';

const RisingKeyword = () => {
  const { RisingKeywordStore } = useStore();
  const { risingKeywordData } = RisingKeywordStore;

  if (!risingKeywordData) return null;

  const { item, title, standardDate } = risingKeywordData;
  const [year, month, date] = standardDate.split('-');
  const formattedDate = `${year}년 ${month}월 ${date}일 기준`;

  return (
    <div className="keyword-ranking">
      <HeadLine title={title} description={formattedDate}>
        <HeadLineMore isRisingKeyword />
      </HeadLine>
      <KeywordRanking keywordRankingData={item} />
    </div>
  );
};

export default observer(RisingKeyword);
